import { gql } from "@apollo/client";

export const GET_ADMINCUSTOMER_DETAILS = gql`
  mutation adminCustomerLookup($phone: String!) {
    adminCustomerLookup(phone: $phone) {
      status
      error
      customer {
        firstname
        lastname
        address1
        address2
        city
        state
        zip
        phone
        email
        country
        gender
        customerid
        datetimecreated
        datetimeupdated
        birthdate
        isEnabled
        plaidverified
        creditCardsCount
        transactionsCount
        totalTransactedAmount
        notes
      }
      recenttransactions {
        ctransid
        gateway
        referenceid1
        datetimecreated
        price
        disputed
      }
      cards {
        bank
        lastfour
      }
      banklist
    }
  }
`;

export const GET_ADMINCUSTOMER_TOGGLE_ACTIVE = gql`
  mutation adminCustomerToggleActiveById($id: String!) {
    adminCustomerToggleActiveById(id: $id) {
      status
      error
    }
  }
`;

export const SET_ADMINCUSTOMER_PLAID_VERIFY = gql`
  mutation adminCustomerSetPlaidVerifyById($id: String!) {
    adminCustomerSetPlaidVerifyById(id: $id) {
      status
      error
    }
  }
`;

export const UPDATE_ADMINCUSTOMER_NOTES = gql`
  mutation adminUpdateCustomerNotes($customerid: String!, $notes: String!) {
    adminUpdateCustomerNotes(customerid: $customerid, notes: $notes) {
      status
      error
      customer {
        notes
      }
    }
  }
`;

export const UPDATE_ADMINCUSTOMER_CARDBANK = gql`
  mutation adminUpdateCustomerCardBank(
    $customerid: String!
    $lastfour: Float!
    $bankname: String!
  ) {
    adminUpdateCustomerCardBank(
      customerid: $customerid
      lastfour: $lastfour
      bankname: $bankname
    ) {
      status
      error
      cards {
        bank
        lastfour
      }
      banklist
    }
  }
`;
